export default __webpack_public_path__ + "static/media/camera_outlined.53a6e30a.svg";